import React from 'react';
import { Highlight, themes } from 'prism-react-renderer';
import { LineRange } from './codeReviewUi';
import styles from './CodeReviewPage.module.css';

interface CodeViewProps {
  code: string;
  language: string;
  fontSize: number;
  selection: LineRange | null;
  // extend : Maj+clic, étend la sélection jusqu'à cette ligne
  onLineClick: (line: number, extend: boolean) => void;
}

// Code coloré ligne par ligne, numéros cliquables pour sélectionner les lignes d'une remarque
const CodeView: React.FC<CodeViewProps> = ({ code, language, fontSize, selection, onLineClick }) => (
  <Highlight theme={themes.vsLight} code={code} language={language}>
    {({ className, style, tokens, getLineProps, getTokenProps }) => (
      <pre className={`${className} ${styles['code-view']}`} style={{ ...style, fontSize }}>
        {tokens.map((line, i) => {
          const lineNumber = i + 1;
          const selected = selection !== null && lineNumber >= selection.start && lineNumber <= selection.end;
          const lineProps = getLineProps({ line });
          return (
            <div
              key={i}
              {...lineProps}
              className={`${lineProps.className} ${styles['code-line']} ${selected ? styles['code-line-selected'] : ''}`}
            >
              <span className={styles['code-line-number']} onClick={(e) => onLineClick(lineNumber, e.shiftKey)}>
                {lineNumber}
              </span>
              <span className={styles['code-line-content']}>
                {line.map((token, key) => <span key={key} {...getTokenProps({ token })} />)}
              </span>
            </div>
          );
        })}
      </pre>
    )}
  </Highlight>
);

export default CodeView;
